import {ErrorMessage, Field, Form, Formik} from 'formik'
import {KTSVG} from '../../../helpers'
import {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {getRequest, postRequest} from '../../../../app/pages/Helpers/Requests'
import * as Yup from 'yup'
import toast from 'react-hot-toast'

function PushLocation() {
  let {pointId} = useParams()
  const [locations, setLocations] = useState<any[]>([])

  // Initial values for Formik
  const initialValues = {
    locationId: '',
  }

  // Handle Submit
  const handleSubmit = async (values: any, {setSubmitting, resetForm}: any) => {
    try {
      const payload = {
        mspId: pointId, 
        locationId: values.locationId, 
      }
      console.log('Payload being sent:', payload)
      const res = await postRequest(`/ocpi/locations/push`, payload)
      if (res && res.data) {
        console.log('Push Location Success:', res.data)
        toast.success('Location pushed successfully!')
        resetForm()
      }
    } catch (error) {
      console.error('Error pushing location:', error)
      toast.error('Failed to push location.')
    } finally {
      setSubmitting(false)
    }
  }

  // Fetch Locations
  const getLocation = async () => {
    try {
      const res = await getRequest(`/all/locations`)
      console.log('location response', res?.data.data.locations)
      if (res && res.data) {
        setLocations(res.data.data.locations)
      }
    } catch (error: any) {
      console.error('Error fetching location:', error)
    }
  }

  useEffect(() => {
    getLocation()
  }, [])

  return (
    <div className='modal fade' tabIndex={-1} id='get_push_location'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header bg-success'>
            <h5 className='modal-title text-white'>Push Location</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-success ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              {({isSubmitting}) => (
                <Form>
                  {/* Location Dropdown */}
                  <div className='col-md-12 mt-3'>
                    <label className='form-label'>Select Location</label>
                    <Field as='select' name='locationId' className='form-control'>
                      <option value=''>-- Select Location --</option>
                      {locations.map((loc, index) => (
                        <option key={index} value={loc.id}>
                          {loc.address}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name='locationId' component='div' className='text-danger' />
                  </div>

                  <div className='modal-footer mt-3'>
                    <button type='button' className='btn btn-light-danger' data-bs-dismiss='modal'>
                      Cancel
                    </button>
                    <button type='submit' disabled={isSubmitting} className='btn btn-light-success'>
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PushLocation
